import React from 'react';
import styled from 'styled-components';

import Section from '../global/section';
import Top from '../top';

const StyledVideo = styled.div`
	text-align: center;
	h2 {
		margin-bottom: 2rem;
	}
	.top {
		text-transform: uppercase;
	}
	.video {
		max-width: 800px;
		width: 80%;
		margin: 0 auto;
		.video-container {
			position: relative;
			padding-bottom: calc(900% / 16);
			iframe {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
		}
		@media all and (max-width: 550px) {
			width: 100%;
		}
	}
`;

export default ({ url, title }) => {
	// Get embed Code
	let embedCode;
	// embed url
	if (url.includes('/embed/')) {
		embedCode = url.split('/embed/')[1];
	} // short url
	else if (url.includes('youtu.be')) {
		embedCode = url.split('.be/')[1];
	} // default watch url
	else {
		// remove other parameters
		embedCode = url.split('&')[0];
		// get embed code
		embedCode = embedCode.split('watch?v=')[1];
	}

	return (
		<>
			{url !== undefined && (
				<StyledVideo>
					<Section bg="light">
						<Top className="top" color="red">
							Video Highlights
						</Top>
						<h2>{!!title ? title : 'Highlights from Musicfest'}</h2>
						<div className="video">
							<div className="video-container">
								<iframe
									width="560"
									height="315"
									id="ytplayer"
									title="YouTube Player"
									src={`https://www.youtube.com/embed/${embedCode}?controls=0&rel=0`}
									frameBorder="0"
									allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen
								/>
							</div>
						</div>
					</Section>
				</StyledVideo>
			)}
		</>
	);
};
